const toggleWithoutAnimation = state => state.app.sidebar.withoutAnimation
const config = state => state.app.config
const palette = state => state.app.config.palette
const isLoading = state => state.app.isLoading
const login = state => state.app.login
const notificacoesTodas = state => state.app.notificacoesTodas
const notificacoes = state => state.app.notificacoes
const changelogs = state => state.app.changelogs
const notificacoesNaoLidas = state => state.app.notificacoesNaoLidas
const notificacoesLidas = state => state.app.notificacoesLidas
const notificacoesArquivadas = state => state.app.notificacoesArquivadas
const unreadNotifications = state => {
  if (state.app.notificacoesTodas) {
    return state.app.notificacoesTodas.filter(n => !n.is_read)
  }

  return []
}

export {
  toggleWithoutAnimation,
  config,
  palette,
  isLoading,
  login,
  notificacoesTodas,
  notificacoes,
  changelogs,
  notificacoesNaoLidas,
  notificacoesLidas,
  notificacoesArquivadas,
  unreadNotifications,
}
